<template>
  <div
    class="border border-gray-900 rounded overflow-hidden divide-y divide-gray-900 bg-white focus-within:ring ring-blue-500 ring-opacity-50"
  >
    <EditorMenuBar v-slot="{ commands, isActive }" :editor="editor">
      <div class="flex divide-x">
        <button
          type="button"
          class="p-2 inline-flex focus:outline-none"
          :class="[
            isActive.bold() ? 'bg-gray-900' : 'bg-white',
            isActive.bold() ? 'text-white' : 'text-gray-800',
          ]"
          @click="commands.bold"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
            <path
              d="M8 11h4.5a2.5 2.5 0 1 0 0-5H8v5zm10
              4.5a4.5 4.5 0 0 1-4.5 4.5H6V4h6.5a4.5 4.5
              0 0 1 3.256 7.606A4.498 4.498 0 0 1 18
              15.5zM8 13v5h5.5a2.5 2.5 0 1 0 0-5H8z"
            />
          </svg>
        </button>

        <button
          type="button"
          class="p-2 inline-flex focus:outline-none"
          :class="[
            isActive.italic() ? 'bg-gray-900' : 'bg-white',
            isActive.italic() ? 'text-white' : 'text-gray-800',
          ]"
          @click="commands.italic"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
            <path d="M15 20H7v-2h2.927l2.116-12H9V4h8v2h-2.927l-2.116 12H15z" />
          </svg>
        </button>

        <button
          type="button"
          class="p-2 inline-flex focus:outline-none"
          :class="[
            isActive.strike() ? 'bg-gray-900' : 'bg-white',
            isActive.strike() ? 'text-white' : 'text-gray-800',
          ]"
          @click="commands.strike"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
            <path
              d="M17.154 14c.23.516.346 1.09.346 1.72
              0 1.342-.524 2.392-1.571 3.147C14.88 19.622
              13.433 20 11.586 20c-1.64
              0-3.263-.381-4.87-1.144V16.6c1.52.877 3.075
              1.316 4.666 1.316 2.551 0 3.83-.732
              3.839-2.197a2.21 2.21 0 0
              0-.648-1.603l-.12-.117H3v-2h18v2h-3.846zm-4.078-3H7.629a4.086
              4.086 0 0 1-.481-.522C6.716 9.92 6.5 9.246
              6.5 8.452c0-1.236.466-2.287 1.397-3.153C8.83
              4.433 10.271 4 12.222 4c1.471 0 2.879.328
              4.222.984v2.152c-1.2-.687-2.515-1.03-3.946-1.03-2.48 0-3.719.782-3.719
              2.346 0 .42.218.786.654 1.099.436.313.974.562
              1.613.75.62.18 1.297.414 2.03.699z"
            />
          </svg>
        </button>

        <button
          type="button"
          class="p-2 inline-flex focus:outline-none"
          :class="[
            isActive.underline() ? 'bg-gray-900' : 'bg-white',
            isActive.underline() ? 'text-white' : 'text-gray-800',
          ]"
          @click="commands.underline"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
            <path d="M8 3v9a4 4 0 1 0 8 0V3h2v9a6 6 0 1 1-12 0V3h2zM4 20h16v2H4v-2z" />
          </svg>
        </button>

        <button
          type="button"
          class="p-2 inline-flex focus:outline-none"
          :class="[
            isActive.paragraph() ? 'bg-gray-900' : 'bg-white',
            isActive.paragraph() ? 'text-white' : 'text-gray-800',
          ]"
          @click="commands.paragraph"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
            <path
              d="M12 6v15h-2v-5a6 6 0 1 1
              0-12h10v2h-3v15h-2V6h-3zm-2 0a4 4 0 1 0 0 8V6z"
            />
          </svg>
        </button>

        <button
          type="button"
          class="p-2 inline-flex focus:outline-none"
          :class="[
            isActive.heading({ level: 1 }) ? 'bg-gray-900' : 'bg-white',
            isActive.heading({ level: 1 }) ? 'text-white' : 'text-gray-800',
          ]"
          @click="commands.heading({ level: 1 })"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
            <path
              d="M13 20h-2v-7H4v7H2V4h2v7h7V4h2v16zm8-12v12h-2v-9.796l-2
              .536V8.67L19.5 8H21z"
            />
          </svg>
        </button>

        <button
          type="button"
          class="p-2 inline-flex focus:outline-none"
          :class="[
            isActive.heading({ level: 2 }) ? 'bg-gray-900' : 'bg-white',
            isActive.heading({ level: 2 }) ? 'text-white' : 'text-gray-800',
          ]"
          @click="commands.heading({ level: 2 })"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
            <path
              d="M4 4v7h7V4h2v16h-2v-7H4v7H2V4h2zm14.5
              4c2.071 0 3.75 1.679 3.75 3.75 0 .857-.288
              1.648-.772 2.28l-.148.18L18.034
              18H22v2h-7v-1.556l4.82-5.546c.268-.307.43-.709.43-1.148
              0-.966-.784-1.75-1.75-1.75-.918 0-1.671.707-1.744
              1.606l-.006.144h-2C14.75 9.679 16.429 8 18.5 8z"
            />
          </svg>
        </button>

        <button
          type="button"
          class="p-2 inline-flex focus:outline-none"
          :class="[
            isActive.heading({ level: 3 }) ? 'bg-gray-900' : 'bg-white',
            isActive.heading({ level: 3 }) ? 'text-white' : 'text-gray-800',
          ]"
          @click="commands.heading({ level: 3 })"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
            <path
              d="M22 8l-.002 2-2.505 2.883c1.59.435
              2.757 1.89 2.757 3.617 0 2.071-1.679
              3.75-3.75 3.75-1.826
              0-3.347-1.305-3.682-3.033l1.964-.382c.156.806.866
              1.415 1.718 1.415.966 0 1.75-.784
              1.75-1.75s-.784-1.75-1.75-1.75c-.286
              0-.556.069-.794.19l-1.307-1.547L19.35
              10H15V8h7zM4 4v7h7V4h2v16h-2v-7H4v7H2V4h2z"
            />
          </svg>
        </button>

        <button
          type="button"
          class="p-2 inline-flex focus:outline-none"
          :class="[
            isActive.bullet_list() ? 'bg-gray-900' : 'bg-white',
            isActive.bullet_list() ? 'text-white' : 'text-gray-800',
          ]"
          @click="commands.bullet_list"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
            <path
              d="M8 4h13v2H8V4zM4.5 6.5a1.5 1.5 0 1 1 0-3
              1.5 1.5 0 0 1 0 3zm0 7a1.5 1.5 0 1 1 0-3
              1.5 1.5 0 0 1 0 3zm0 6.9a1.5 1.5 0 1 1
              0-3 1.5 1.5 0 0 1 0 3zM8 11h13v2H8v-2zm0 7h13v2H8v-2z"
            />
          </svg>
        </button>

        <button
          type="button"
          class="p-2 inline-flex focus:outline-none"
          :class="[
            isActive.ordered_list() ? 'bg-gray-900' : 'bg-white',
            isActive.ordered_list() ? 'text-white' : 'text-gray-800',
          ]"
          @click="commands.ordered_list"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
            <path
              d="M8 4h13v2H8V4zM5 3v3h1v1H3V6h1V4H3V3h2zM3
              14v-2.5h2V11H3v-1h3v2.5H4v.5h2v1H3zm2
              5.5H3v-1h2V18H3v-1h3v4H3v-1h2v-.5zM8
              11h13v2H8v-2zm0 7h13v2H8v-2z"
            />
          </svg>
        </button>
      </div>
    </EditorMenuBar>

    <EditorContent :editor="editor" />
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions';
import TurndownService from 'turndown';
import { marked } from 'marked';
import { debounce } from 'lodash-es';

const turndownService = new TurndownService();

export default {
  components: {
    EditorContent,
    EditorMenuBar,
  },

  props: {
    content: {
      type: String,
      default: '',
    },
    customEditorClasses: {
      type: Array,
      default: () => [],
    },
    readOnly: Boolean,
  },

  data() {
    const vm = this;
    return {
      editor: new Editor({
        editable: !this.readOnly,
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
        ],
        editorProps: {
          attributes: {
            class: [
              'focus:outline-none',
              'p-4',
              'prose',
              'prose-sm',
              ...this.customEditorClasses,
            ].join(' '),
          },
        },
        onUpdate: debounce(({ getHTML }) => {
          const html = getHTML();
          vm.handleInput(html);
        }, 500),
        onBlur: () => {
          this.handleBlur(this.editor.getHTML());
        },
      }),
    };
  },

  watch: {
    readOnly(value) {
      this.editor.setOptions({ editable: !value });
    },
  },

  created() {
    this.editor.setContent(marked(this.content || ''));
  },

  destroyed() {
    this.editor.destroy();
  },

  methods: {
    handleInput(html) {
      this.$emit('input', turndownService.turndown(html));
    },
    handleBlur(html) {
      this.$emit('change', turndownService.turndown(html));
    },
  },
};
</script>
